import { Edit } from "react-admin";
import { PromoForm } from "./Form";

export function PromoEdit() {
  return (
    <Edit redirect="list" mutationMode="pessimistic">
      <PromoForm />
    </Edit>
  );
}
